import React from 'react';
import '../../../../styles/_style.scss';
import Error from '../../../../images/error_illustration.svg';

export default () => (
    <div className="error">
        <div className="error__container">
            <div className="error__illustration">
                <img src={Error} alt="Error 404"/>
            </div>
            <h1>404</h1>
            <h4>Page Not Found!!</h4>
            <p>The page you're looking doesn't exist.</p>
        </div>
    </div>
)



// WEBPACK FOOTER //
// ./src/containers/Layouts/Default/Notfound/index.js